import { Injectable } from '@angular/core';
import {
    Apotheke,
    ApothekenGruppe,
    ApothekenKooperation,
    Page,
} from 'src/app/shared/model';
import { Observable, Subject } from 'rxjs';
import {ApothekenFilter} from '../../../shared/model/apotheke/apotheken-filter';

@Injectable()
export abstract class ApothekenService {
    zuweisungApotheken: Apotheke[] = [];
    zuweisungApothekenGruppen: ApothekenGruppe[] = [];
    zuweisungApothekenKooperationen: ApothekenKooperation[] = [];

    zuweisungApothekenSubject = new Subject<Apotheke[]>();
    zuweisungApothekenGruppenSubject = new Subject<ApothekenGruppe[]>();
    zuweisungApothekenKooperationenSubject = new Subject<
        ApothekenKooperation[]
    >();

    abstract getApothekenVonIndustriepartner(
        page: number,
        size: number,
        kooperation: ApothekenKooperation,
        gruppe: ApothekenGruppe,
        filter: ApothekenFilter
    ): Observable<Page<Apotheke>>;
    abstract getAllApothekenVonIndustriepartner(): Observable<Apotheke[]>;
    abstract getApothekenGruppenVonIndustriepartner(): Observable<
        ApothekenGruppe[]
    >;
    abstract getApothekenKooperationenVonIndustriepartner(): Observable<
        ApothekenKooperation[]
    >;

    abstract setApotheken(apotheken: Apotheke[]): void;
    abstract setApothekenGruppen(apothekenGruppen: ApothekenGruppe[]);
    abstract setApothekenKooperationen(
        apothekenKooperationen: ApothekenKooperation[]
    );
    abstract getApotheken(): Observable<Apotheke[]>;
    abstract getApothekenGruppen(): Observable<ApothekenGruppe[]>;
    abstract getApothekenKooperationen(): Observable<ApothekenKooperation[]>;
    abstract getApothekenCount(): Observable<number>;
    abstract getIndustriepartnerVerfuegbareKooperationen();
    abstract getIndustriepartnerVerfuegbareGruppen();
    abstract getBgaErrors(anbieterNummer);
    abstract storeEditedBga(data);
}
